export class BackupControlViolations {
    'high';
    'medium';
    'low';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "high",
            "baseName": "high",
            "type": "ControlViolationsPerSeverity",
            "format": ""
        },
        {
            "name": "medium",
            "baseName": "medium",
            "type": "ControlViolationsPerSeverity",
            "format": ""
        },
        {
            "name": "low",
            "baseName": "low",
            "type": "ControlViolationsPerSeverity",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupControlViolations.attributeTypeMap;
    }
    constructor() {
    }
}
